import { createNextState } from '@reduxjs/toolkit';

import type { QueryRejectedAction } from './actions/createQueryRejectedActionMatcher';
import type { AnyApiState } from './types';

/**
 * По умолчанию RTK Query не проставляет поле fulfilledTimeStamp в случае ошибки.
 * Из-за этого при маунте компонента делается повторный запрос после вызова эффектов,
 * так как queryThunk опирается на поле fulfilledTimeStamp внутри thunk.condition.
 *
 * @param state Стейт.
 * @param action Экшен query.rejected.
 * @returns Стейт с проставленным полем fulfilledTimeStamp.
 */
export function addFulfilledTimeStamp<State extends AnyApiState>(state: State, action: QueryRejectedAction) {
    return createNextState(state, draft => {
        const {
            meta: { condition, arg, requestId },
        } = action;
        const queryState = draft.queries[arg.queryCacheKey];

        // Выполнение запроса было отменено по условию
        if (condition) {
            return;
        }

        // Во время выполения запроса данные были удалены из стора
        if (!queryState) {
            return;
        }

        // Во время выполнения запроса был выполнен новый запрос, поэтому
        // текущий потерял актуальность
        if (queryState.requestId !== requestId) {
            return;
        }

        // Проставляем поле только в том случае, если его еще нет.
        // Это будет ошибка в самом первом запросе, когда не было ни одного успешного запроса.
        if (!queryState.fulfilledTimeStamp) {
            queryState.fulfilledTimeStamp = Date.now();
        }
    });
}
